import { render, staticRenderFns } from "./order-transfer.vue?vue&type=template&id=482c8398&scoped=true"
import script from "./order-transfer.vue?vue&type=script&lang=js"
export * from "./order-transfer.vue?vue&type=script&lang=js"
import style0 from "./order-transfer.vue?vue&type=style&index=0&id=482c8398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c8398",
  null
  
)

export default component.exports